<template>
  <content-items-list
    content-type="trial-playlists"
    content-type-singular="trial-playlist"
    content-name="Trial Playlists"
    content-name-singular="Trial Playlist"
  />
</template>

<script>
import ContentItemsList from '@/views/content-item/content-items-list/ContentItemsList.vue'

export default {
  components: {
    ContentItemsList,
  },
}
</script>

<style scoped>

</style>
